<template>
  <div>
    <a-modal
      :z-index="1001"
      :visible="visible"
      wrapClassName="update_info"
      :keyboard="false"
      :maskClosable="false"
      width="600px"
      :mask="false"
      :destroyOnClose="true"
      :footer="null" @cancel="visible = false">
      <div slot="title" class="title_div">
        <div class="title_content">
          <div>{{ $t('keygengxintishi') }}</div>
          <div>{{$t('keyxinbanben')}}:{{updateInfo.versionNumber}}</div>
        </div>
      </div>
      <div class="content">
        <div class="content_div">
          <div class="item">{{ $t('keygengxinshuoming') }}</div>
          <div class="update_info_content" v-html="updateInfo.content"></div>
        </div>
      </div>
      <div style="height: 30px;"></div>
    </a-modal>
  </div>

</template>

<script>
  import Api from '@/api/sys/updateInfo'
  export default {
    name: 'updateInfo',
    data(){
      return {
        visible:false,
        updateInfo:{}
      }
    },
    mounted() {
      this.initData()
    },
    methods:{
      initData(){
        Api.selectAll().then(res=>{
          if(res.code == 1){
            if(res.data){
              this.visible = true
              this.updateInfo = res.data
            }
          }
        })
      }
    }

  }
</script>

<style lang="less">
  .update_info{
    .title_div{
      background-image: url("~@/assets/update.png");
      height: 134px;
      background-size: cover;
      text-align: left;
      .title_content{
        display: flex;
        padding-left: 67px;
        flex-direction: column;
        height: 134px;
        justify-content: center;
        align-content: center;
        div:first-child{
          font-size: 24px;
          color: #FFFFFF;
        }
        div:last-child{
          padding-top: 8px;
          font-size: 12px;
          color: #999999;
        }
      }
    }

    .ant-modal-header{
      padding: 0px;
    }
    .ant-modal{
      top: 60px !important;
      padding-bottom: 0px !important;
    }
    .ant-modal-close-x{
      color: #ffffff;
      font-size: 20px !important;
    }
    .ant-modal-body{
      padding: 0px !important;
    }
    .content{
      height: 360px;
      padding: 35px 67px 0px;
      overflow-y: auto;
      .content_div{
        text-align: justify;
        .item{
          font-weight: bold;
          font-size: 14px;
          margin-bottom: 15px;
        }
        .update_info_content{
          ol{
            margin-left: -25px;
            line-height: 15px;
          }
        }
      }
    }
  }
</style>
